import { Progress, Text, VStack } from '@chakra-ui/react';

const getProgressColor = (percent) => {
  if (percent >= 100) return 'red.500';
  if (percent >= 75) return 'orange.400';
  if (percent >= 50) return 'yellow.400';
  return 'green.400';
};

export const ProgressBar = ({ current = 0, total = 0 }) => {
  const percent = total > 0 ? Math.min((current / total) * 100, 100) : 0;
  const color = getProgressColor(percent);

  return (
    <VStack spacing={1} align="center">
      <Progress
        value={percent}
        size="xs"
        width="100px"
        colorScheme="whiteAlpha"
        sx={{
          '& > div:first-of-type': {
            backgroundColor: color,
          },
        }}
        borderRadius="lg"
      />
      <Text fontSize="xx-small" color="whiteAlpha.800">
        {current.toLocaleString()} / {total.toLocaleString()} ({Math.round(percent)}%)
      </Text>
    </VStack>
  );
};
